module Shared {
    export interface IFrendsResult<T> {
        success: boolean;
        data: T;
        errorMessage: string;
    }
}